import PropTypes from "prop-types";

import { Box } from "@mui/material";

import { IconButtonAnimate } from "../../../components/animate";

CollapseButton.propTypes = {
  collapseClick: PropTypes.bool,
  onToggleCollapse: PropTypes.func,
};

export default function CollapseButton({ onToggleCollapse, collapseClick }) {
  return (
    <IconButtonAnimate onClick={onToggleCollapse}>
      <Box
        sx={{
          lineHeight: 0,
          transition: (theme) =>
            theme.transitions.create("transform", {
              duration: theme.transitions.duration.shorter,
            }),
          ...(collapseClick && {
            transform: "rotate(180deg)",
          }),
        }}
      >
        {icon}
      </Box>
    </IconButtonAnimate>
  );
}

const icon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0303 6.4697C15.3232 6.76259 15.3232 7.23747 15.0303 7.53036L10.5607 12L15.0303 16.4697C15.3232 16.7626 15.3232 17.2374 15.0303 17.5303C14.7374 17.8232 14.2626 17.8232 13.9697 17.5303L8.9697 12.5303C8.829 12.3897 8.75 12.1989 8.75 12C8.75 11.8011 8.829 11.6103 8.9697 11.4697L13.9697 6.4697C14.2626 6.17681 14.7374 6.17681 15.0303 6.4697Z"
      fill="#2C2C2C"
    />
  </svg>

  // <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
  //   <g fill="none" fillRule="evenodd">
  //     <path d="M0 0h24v24H0z" />
  //     <g fill="currentColor" fillRule="nonzero">
  //       <path
  //         d="M14.3283 11.4343 18.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z"
  //         opacity=".48"
  //       />
  //       <path d="M8.3283 11.4343 12.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z" />
  //     </g>
  //   </g>
  // </svg>
);
